const uniqueSortedTitles = (titles: (string | null | undefined)[]) =>
  [...new Set(titles.filter((title): title is string => Boolean(title)))].sort();

export const createMigrationManifest = (titles: (string | null | undefined)[]) =>
  uniqueSortedTitles(titles).join('\n');

export const getIntroducedMigrations = (
  manifest: string,
  currentTitles: (string | null | undefined)[]
) => {
  const currentMigrationTitles = new Set(uniqueSortedTitles(currentTitles));
  const manifestTitles = manifest.split(/\r?\n/).map((title) => title.trim());

  return uniqueSortedTitles(manifestTitles).filter((title) => !currentMigrationTitles.has(title));
};
